module.exports = __webpack_public_path__ + "i18n/pl.dbf73279bf80a9b15209a5df52fd42c7.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pl.json
// module id = 1544
// module chunks = 60